import { Box, Typography } from "@material-ui/core";
import { formatRowToData } from "../RemarksListingPage";
import RemarksForm from "../RemarksForm";

export default function EditRemarksPage({disabled, ...props}) {
  return (
    <>
      <Box width="100%">
        <Typography variant="h4" gutterBottom>
          Remarks &gt; Edit Remarks
        </Typography>
      </Box>
        <RemarksForm
          description="Edit Remark"
          submitBtnTxt="Save Changes"
          gridSize={6}
          history={props.history}
          formatRowToData={formatRowToData}
          disabled={disabled}
        />
    </>
  );
}
